import React, { PureComponent } from 'react';
import { Image } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
class Product extends PureComponent {
  redirectToDetail = () => {
    // console.log('props', this.props);
    this.props.history.push({
      pathname: `/clientwebsite2/productDetail/${this.props.media.instagram_pid}`,
      // Change later to /productDetail
      state: {
        media: this.props.media,
        whatsappLink: this.props.whatsappLink,
        businessName: this.props.businessName,
      },
    });
  };
  render() {
    const { selected, dashboard, currency, translate } = this.props;
    const price = this.props.media.prices && this.props.media.prices.length > 0 && this.props.media.prices.find(pr => pr.currency === currency)

    return (

      <div
        onClick={() => {
          if (dashboard) {
            this.props.addToCart(this.props.media)
          } else
            this.redirectToDetail()
        }}
        key={this.props.media.id}
        className={`popularProductDetailContainer ${this.props.language === "ar" ? "popularProductDetailContainerRTL" : ""}`}>
        {selected ?
          <Image
            className="notSelected"
            src="/assets/images/svgs/Error.svg"
          />
          : <div className="emptyDiv"></div>
        }
        <div className={`imageDiv ${selected ? "selectedImage" : ""} ${!this.props.media.name && !price && "removeProductInfo"}`}>
          <Image src={this.props.media.media && this.props.media.media.length > 0 && this.props.media.media[0].url} alt={this.props.media.productName} />
        </div>
        {(this.props.media.name || price) &&
          <div className="prodInfo">
            <h4 className="productName">
              {this.props.media.name ? this.props.media.name : ''}
            </h4>

            <h3 className={"productPrice"}>
              {price ? (
                <div>
                  <span className={`${this.props.language === "ar" && "arabic"}`}>{translate[price.currency]}</span>
                  {price.price}
                </div>
              ) : (
                  <div style={{ height: 17 }}>

                  </div>
                )}
            </h3>
          </div>
        }
      </div>

    );
  }
}

export default withRouter(Product);



// WEBPACK FOOTER //
// ./src/components/PopularProduct.js